import PlusIconPath from "@ingka/ssr-icon/paths/plus";

export default PlusIconPath;
